export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/util/eventConsts.js
// module id = 4168
// module chunks = 25